import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { ConditionViewModel, ConditionCreateModel, ConditionUpdateModel } from '../types/condition';
import { apiClient } from '../client/client';

export class ConditionService {
  private static readonly BASE = '/api/condition';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(): Promise<ServiceResultT<ConditionViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<ConditionViewModel[]>>(
      ConditionService.BASE
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<ConditionViewModel>> {
    const { data } = await this.client.get<ServiceResultT<ConditionViewModel>>(
      `${ConditionService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: ConditionCreateModel): Promise<ServiceResultT<ConditionViewModel>> {
    const { data } = await this.client.post<ServiceResultT<ConditionViewModel>>(
      ConditionService.BASE,
      payload
    );
    return data;
  }

  async update(id: number | string, payload: ConditionUpdateModel): Promise<ServiceResultT<ConditionViewModel>> {
    const { data } = await this.client.put<ServiceResultT<ConditionViewModel>>(
      `${ConditionService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${ConditionService.BASE}/${id}`);
    return data;
  }
}

export const conditionService = new ConditionService();
